import Analytics from "./components/Analytics";
import Cards from "./components/Cards";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";

function App() {
  return (
    <div className="">
      <Navbar />
      <Hero />
      <Analytics />
      <Contact />
      <Cards />
      <Footer />
    </div>
  );
}

export default App;
